module.exports = __webpack_public_path__ + "img/加拿大.b2a0ab12.jpg";